import React from 'react';

import { DropdownButton, Dropdown as DropdownBS } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { Pencil2Icon, ThreeVerticalDotsIcon, TrashcanIcon } from 'assets/icons';

interface IDropdownGroup {
  dataTestId: string;
  onShowEditModal: () => void;
  onShowDeleteModal: () => void;
  disabled?: boolean;
}

const DropdownGroup = ({
  dataTestId,
  onShowEditModal,
  onShowDeleteModal,
  disabled
}: IDropdownGroup) => {
  const intl = useIntl();

  return (
    <DropdownButton
      data-test={`${dataTestId}-dropdown`}
      variant="link"
      title={<ThreeVerticalDotsIcon className="icon" />}
      align="end"
      className="no-caret float-right"
      disabled={disabled}
    >
      <DropdownBS.Item data-test={`${dataTestId}-dropdown-edit`} onClick={onShowEditModal}>
        <Pencil2Icon className="icon pe-2" />
        <span>{intl.formatMessage({ id: 'editKey' })}</span>
      </DropdownBS.Item>
      <DropdownBS.Item data-test={`${dataTestId}-dropdown-delete`} onClick={onShowDeleteModal}>
        <TrashcanIcon className="icon pe-2" />
        <span>{intl.formatMessage({ id: 'deleteKey' })}</span>
      </DropdownBS.Item>
    </DropdownButton>
  );
};

export default DropdownGroup;
